import { useEffect, useState } from "react";
import { useGetDropdownOptionsQuery, useGetFiEmpLocationQuery } from "../../services/vendor/VendorApi";
import { OptionType } from "../../utils/types";
import { SelectInput } from "../../utils/input";

const LocationDropdown = ({ formData, handleSelectChange, isReadOnly, isMM }) => {
  const {
    data: dropdownList,
    error,
    isLoading,
    isFetching,
    isSuccess,
    isError,
  } = useGetFiEmpLocationQuery(formData.isPoModuleSelected === "No" ? "profit_center" : "plant", { skip: isMM }); //useGetDropdownOptionsQuery(formData.isPoModuleSelected === "No" ? "profit_center" : "plant", { skip: isMM });

  const [selectOptions, setSelectOptions] = useState<OptionType[]>();

  useEffect(() => {
    if (isMM) {
      if (formData?.poContractDetails?.plant_code) {
        const code = formData?.poContractDetails?.plant_code;
        const name = formData?.poContractDetails?.plant_name;
        setSelectOptions([{ value: code, label: `${code} - ${name}` }]);
        formData.invoiceForWhichLocation = code;
        formData.location_name = name;
      }
    } else {
      if (formData.isPoModuleSelected === "No") {
        setSelectOptions(
          dropdownList?.d?.results?.map((item) => {
            return {
              value: item?.pa,
              label: `${item?.pa} - ${item?.pa_txt}`,
            };
          })
        );
      } else {
        setSelectOptions(
          dropdownList?.d?.results?.map((item) => {
            return {
              value: item?.zro,
              label: `${item?.zro} - ${item?.zrodesc}`,
            };
          })
        );
      }
    }
  }, [dropdownList, formData, isMM]);

  const handleLocationSelectChange = (name, val) => {
    const label = dropdownList?.d?.results?.filter((item) => item?.pa === val);
    handleSelectChange(name, { label: label?.[0]?.pa_txt, value: val });
  };

  return (
    <SelectInput
      name="invoiceForWhichLocation"
      required
      label="Invoice for which location?"
      value={formData.invoiceForWhichLocation}
      loading={isFetching || isLoading}
      options={selectOptions ?? []}
      onChange={(key, val) => handleLocationSelectChange(key, val)}
      placeholder="Select Location"
      disabled={isReadOnly || isMM}
    />
  );
};

export default LocationDropdown;
